// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1S0Al","placeholdersHeader":"styles_placeholdersHeader__20Osh","editorStyle":"styles_editorStyle__1OxpH","placeholdersBox":"styles_placeholdersBox__1ReQ-"};